/* eslint-disable */
export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/acount/login")
  },
  {
    path: "",
    component: () => import("@/pages/index"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/",
    component: () => import("@/layouts/master/index"),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "/incidencias/",
        name: "incidencias",
        component: () => import("@/pages/incidencias/index")
      },
      {
        path: "/clientes/",
        name: "clientes",
        component: () => import("@/pages/clientes/index"),
        meta: {
          requiresTecnico: true
        }
      },
      {
        path: "/ClientesEdit/:clienteProp?",
        name: "ClientesEdit",
        props: true,
        component: () => import("@/pages/clientes/edit")
      },
      {
        path: "/InstalacionEdit/:clienteProp?/:instalacionProp?",
        name: "InstalacionEdit",
        props: true,
        component: () => import("@/pages/clientes/editInstalacion")
      },
      {
        path: "/ContactoEdit/:nombreProp?",
        name: "ContactoEdit",
        props: true,
        component: () => import("@/pages/clientes/editContacto")
      },
      {
        path: "/incidencias/:clienteProp?/:instalacionProp?/:incidenciaProp?",
        name: "incidenciasEdit",
        props: true,
        component: () => import("@/pages/incidencias/edit")
      },
      {
        path: "/partes",
        component: () => import("@/pages/partes/index")
      },
      {
        path: "/estadisticas/tecnicos",
        component: () => import("@/pages/estadisticas/tecnicos"),
        meta: {
          requiresTecnico: true
        }
      },
      {
        path: "/instalaciones/:clienteProp?/:instalacionProp?",
        name: "instalaciones",
        props: true,
        component: () => import("@/pages/instalaciones/index"),
        meta: {
          requiresTecnico: true
        }
      },
      {
        path: "/areasDeTrabajo/",
        name: "areasDeTrabajo",
        component: () => import("@/pages/areasDeTrabajo/"),
        meta: {
          requiresTecnico: true
        }
      },
      {
        path: "/departamentos/",
        name: "departamentos",
        component: () => import("@/pages/departamentos/"),
        meta: {
          requiresTecnico: true
        }
      },
      {
        path: "/prioridad/",
        name: "prioridad",
        component: () => import("@/pages/prioridad"),
        meta: {
          requiresTecnico: true
        }
      },
      {
        path: "/programa/",
        name: "programa",
        component: () => import("@/pages/programas"),
        meta: {
          requiresTecnico: true
        }
      },
      {
        path: "/sistemasOperativos/",
        name: "sistemasOperativos",
        component: () => import("@/pages/sistemasOperativos"),
        meta: {
          requiresTecnico: true
        }
      },
      {
        path: "/tipoIncidencia/",
        name: "tipoIncidencia",
        component: () => import("@/pages/tipoIncidencia"),
        meta: {
          requiresTecnico: true
        }
      },
      {
        path: "/usuarios/",
        name: "usuarios",
        component: () => import("@/pages/usuarios"),
        meta: {
          requiresTecnico: true
        }
      },
      {
        path: "/operario/",
        name: "operario",
        component: () => import("@/pages/operario"),
        meta: {
          requiresTecnico: true
        }
      }
    ]
  },

  {
    // Always leave this as last one
    path: "*",
    component: () => import("@/pages/404")
  }
];
